/**
 * The public App Store listing for HeadToHead — the single source of truth for
 * the "get the app / update now" link (the force-update gate, Settings → Rate).
 */
export const APP_STORE_URL = 'https://apps.apple.com/dk/app/headtohead/id6755700049';

/**
 * Open an external URL from inside the app. On native, Capacitor routes a
 * `window.open(..., '_blank')` to the system handler — an `apps.apple.com` link
 * opens the App Store app; everything else opens in Safari. On web it's a normal
 * new tab. Matches the pattern already used across the app.
 */
export function openExternal(url: string): void {
  window.open(url, '_blank', 'noopener');
}
